import * as React from 'react';
import styled from 'styled-components';

interface IProps extends Omit<React.HTMLAttributes<HTMLIFrameElement>, 'src'> {
  videoParams: {
    id: string;
    [key: string]: any;
  };
}

export const VimeoPlayer: React.FC<IProps> = ({ videoParams, ...shared }) => {
  return <Root src={getSrc(videoParams)} frameBorder='0' allowFullScreen {...shared} />;

  function getSrc({ id, ...params }) {
    let src = `https://player.vimeo.com/video/${id}`;
    const paramsArray = [];
    for (const param in params) {
      if (Object.prototype.hasOwnProperty.call(params, param)) {
        paramsArray.push(`${param}=${params[param]}`);
      }
    }
    const paramsString = paramsArray.join('&');
    if (paramsString) src += `?${paramsString}`;
    return src;
  }
};

const Root = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
`;
